<template>
    <div class="m-c-list-results">
        {{ shown }} {{ $t.message("numResultsOf") }} {{ total }}
        {{ $t.message("numResultsProjects") }}:
    </div>
</template>

<script>
export default {
    name: "ListResults",
    computed: {
        // total number of projects
        total() {
            return this.$store.getters.filteredItemsCount;
        },
        // current amount of shown projects depending on current page
        shown() {
            return this.$store.getters.pagedItemsShown;
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
